module.exports = __webpack_public_path__ + "img/1953.3c727ea1.png";